import { CHECK_ENTRY_PASS_EXISTS_ACTION_TYPE, GET_EXHIBITION_START_DATE_ACTION_TYPE, GET_VENDOR_EXHIBITION_LIST__ACTION_TYPE, MARK_ORDER_SEEN_ACTION_TYPE} from "../../../utils/constants";


const initialState = [];

function getVendorExhibitionListReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GET_VENDOR_EXHIBITION_LIST__ACTION_TYPE:
            return [...state, payload];
        case GET_EXHIBITION_START_DATE_ACTION_TYPE:
            return [...state, payload];
        case MARK_ORDER_SEEN_ACTION_TYPE:
            return [...state, payload];
        case CHECK_ENTRY_PASS_EXISTS_ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default getVendorExhibitionListReducer